document.addEventListener('DOMContentLoaded', function () {

  // preloader — only runs once per session so repeat page loads on the same
  // visit are not slowed down
  var preloader = document.getElementById('lx-preloader');
  if (preloader) {
    if (sessionStorage.getItem('lx-seen')) {
      preloader.style.display = 'none';
    } else {
      window.addEventListener('load', function () {
        setTimeout(function () {
          preloader.classList.add('lx-done');
          sessionStorage.setItem('lx-seen', '1');
        }, 700);
      });
    }
  }

  // scroll reveal
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('lx-in-view');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.lx-fade-up, .lx-gold-divider, .lx-card').forEach(function (el) {
    io.observe(el);
  });

  // animated stat counters
  document.querySelectorAll('[data-lx-count]').forEach(function (el) {
    var target = parseFloat(el.dataset.lxCount);
    var suffix = el.dataset.lxSuffix || '';
    var divide = el.dataset.lxDivide ? parseFloat(el.dataset.lxDivide) : 1;
    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var dur = 1400;
          var t0 = performance.now();
          function tick(now) {
            var p = Math.min((now - t0) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            var val = target * eased;
            val = divide !== 1 ? (val / divide).toFixed(1) : Math.round(val);
            el.textContent = val + suffix;
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
          counterIO.unobserve(el);
        }
      });
    }, { threshold: 0.5 });
    counterIO.observe(el);
  });

  // scroll progress bar + hero parallax
  var progressBar = document.getElementById('lx-progress');
  var heroBg = document.querySelector('.lx-hero-bg');
  window.addEventListener('scroll', function () {
    if (progressBar) {
      var h = document.documentElement;
      var scrolled = (h.scrollTop) / (h.scrollHeight - h.clientHeight) * 100;
      progressBar.style.width = scrolled + '%';
    }
    if (heroBg) {
      var y = window.scrollY;
      heroBg.style.transform = 'translateY(' + (y * 0.25) + 'px) scale(1.06)';
    }
  }, { passive: true });

  // custom cursor (desktop only — CSS hides it on coarse pointers)
  var dot = document.getElementById('lx-cursor-dot');
  var ring = document.getElementById('lx-cursor-ring');
  if (dot && ring && window.matchMedia('(pointer:fine)').matches) {
    var mx = 0, my = 0, rx = 0, ry = 0;
    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px'; dot.style.top = my + 'px';
    });
    (function loop() {
      rx += (mx - rx) * 0.15; ry += (my - ry) * 0.15;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(loop);
    })();
    document.querySelectorAll('a, .lx-card, .lx-why-item').forEach(function (el) {
      el.addEventListener('mouseenter', function () { ring.classList.add('hovering'); });
      el.addEventListener('mouseleave', function () { ring.classList.remove('hovering'); });
    });
  }

  // magnetic floating WhatsApp button
  var waWrap = document.getElementById('lx-wa-wrap');
  var waBtn = document.getElementById('lx-wa-btn');
  if (waWrap && waBtn) {
    waWrap.addEventListener('mousemove', function (e) {
      var r = waWrap.getBoundingClientRect();
      var relX = e.clientX - r.left - r.width / 2;
      var relY = e.clientY - r.top - r.height / 2;
      waBtn.style.transform = 'translate(' + relX * 0.35 + 'px,' + relY * 0.35 + 'px)';
    });
    waWrap.addEventListener('mouseleave', function () {
      waBtn.style.transform = 'translate(0,0)';
    });
  }
});
